import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { Job } from '../job/job.model';
import { Qry } from '../query-facade';
import * as actions from './file.actions';
import { File } from './file.model';

export class FileStoreFacade extends AccountObjectStoreFacade<File> {

    getAll(): Observable<Array<File>> {
        return this.select(Qry.getInstance().file.byActiveAccount);
    }

    create(file: File): void {
        this.dispatch(new actions.SubmitAction(file));

        this.appFacade.objects.job.store.get(file.job).take(1).subscribe(job => {
            this.appFacade.objects.job.store.attachFile(job, file);
        });
    }

    update(file: File): void {
        this.dispatch(new actions.SubmitAction(file));
    }

    insert(file: File): void {
        this.dispatch(new actions.SubmitAction(file, {persistable: true, restful: false}));
    }

    remove(file: File, options?: ActionOptionsArgs): void {

        this.appFacade.objects.job.store.getAll().take(1).subscribe(jobs => {
            jobs.forEach(job => this.appFacade.objects.job.store.detachFile(job, file));
        });

        this.dispatch(new actions.RemoveAction(file, options));
    }

    removeByJob(job: Job, options?: ActionOptionsArgs): void {
        this.removeBy(file => file.job === job.id, options);
    }

    updateFromApi(files: Array<File>): void {
        this.dispatch(new actions.UpdateFromApi({files}));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file.store-facade.ts